import { createSlice } from "@reduxjs/toolkit";
import { RaisedDisputeData } from "../../../data/arJsonData";

const initialCustomerState = {
  RaisedDispute: RaisedDisputeData,
  showCustomerData: true,
};

const raisedDisputeSlice = createSlice({
  name: "raisedDispute",
  initialState: initialCustomerState,
  reducers: {
    updateCustomer(state, action) {
      const index = state.customers.findIndex(
        (item) => item.id === action.payload.id
      );
      if (index !== -1) {
        state.customers[index] = action.payload;
      }
    },

    addCustomer: (state, action) => {
      state.customers.push(action.payload);
    },
  },
});

// Exporting actions
export const { updateCustomer, toggleShowCustomer, addCustomer } =
  raisedDisputeSlice.actions;

export default raisedDisputeSlice.reducer;
